module.exports = __webpack_public_path__ + "static/media/400050_02.7f1b0739.png";